/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupJobTypeFilters } from '../models/BackupJobTypeFilters';
import { BooleanFilters } from '../models/BooleanFilters';
import { EndTimeDateFilters } from '../models/EndTimeDateFilters';
import { IdFilters } from '../models/IdFilters';
import { InitiatorNameFilters } from '../models/InitiatorNameFilters';
import { JobIdFilters } from '../models/JobIdFilters';
import { JobStatusFilters } from '../models/JobStatusFilters';
import { ProviderAccountIdFilters } from '../models/ProviderAccountIdFilters';
import { ResourceIdFilters } from '../models/ResourceIdFilters';
import { ResourceNameFilters } from '../models/ResourceNameFilters';
import { ResourceTypeFilters } from '../models/ResourceTypeFilters';
import { SnapshotIdFilters } from '../models/SnapshotIdFilters';
import { StartTimeDateFilters } from '../models/StartTimeDateFilters';

export class BackupJobsFilterConditions {
  'id'?: IdFilters;
  'jobId'?: JobIdFilters;
  'snapshotId'?: SnapshotIdFilters;
  'status'?: JobStatusFilters;
  'providerResourceId'?: ResourceIdFilters;
  'backupType'?: BackupJobTypeFilters;
  'startTime'?: StartTimeDateFilters;
  'endTime'?: EndTimeDateFilters;
  'vaultId'?: IdFilters;
  'resourceType'?: ResourceTypeFilters;
  'providerAccountId'?: ProviderAccountIdFilters;
  'resourceName'?: ResourceNameFilters;
  'internalResourceId'?: IdFilters;
  'initiatorName'?: InitiatorNameFilters;
  'isOnDemand'?: BooleanFilters | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "IdFilters",
      "format": ""
    },
    {
      "name": "jobId",
      "baseName": "jobId",
      "type": "JobIdFilters",
      "format": ""
    },
    {
      "name": "snapshotId",
      "baseName": "snapshotId",
      "type": "SnapshotIdFilters",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "JobStatusFilters",
      "format": ""
    },
    {
      "name": "providerResourceId",
      "baseName": "providerResourceId",
      "type": "ResourceIdFilters",
      "format": ""
    },
    {
      "name": "backupType",
      "baseName": "backupType",
      "type": "BackupJobTypeFilters",
      "format": ""
    },
    {
      "name": "startTime",
      "baseName": "startTime",
      "type": "StartTimeDateFilters",
      "format": ""
    },
    {
      "name": "endTime",
      "baseName": "endTime",
      "type": "EndTimeDateFilters",
      "format": ""
    },
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "IdFilters",
      "format": ""
    },
    {
      "name": "resourceType",
      "baseName": "resourceType",
      "type": "ResourceTypeFilters",
      "format": ""
    },
    {
      "name": "providerAccountId",
      "baseName": "providerAccountId",
      "type": "ProviderAccountIdFilters",
      "format": ""
    },
    {
      "name": "resourceName",
      "baseName": "resourceName",
      "type": "ResourceNameFilters",
      "format": ""
    },
    {
      "name": "internalResourceId",
      "baseName": "internalResourceId",
      "type": "IdFilters",
      "format": ""
    },
    {
      "name": "initiatorName",
      "baseName": "initiatorName",
      "type": "InitiatorNameFilters",
      "format": ""
    },
    {
      "name": "isOnDemand",
      "baseName": "isOnDemand",
      "type": "BooleanFilters",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupJobsFilterConditions.attributeTypeMap;
  }

  public constructor() {
  }
}

